export const Urls = {
    GetCustomer: "customer/GetCustomer",
    GetCustomers: "customer/GetCustomers",
    GetCustomerRuleParameters: "customer/GetCustomerRuleParameters",
    GetBusinessUnitRuleParameters: "customer/GetBusinessUnitRuleParameters",
    GetReadOnlyIf: "customer/GetReadOnlyIf",
    GetDisplayResultJson: "customer/GetDisplayResultJson",
    GetCurrentCustomer: "customer/GetCurrentCustomer",
    GetBusinessUnits: "customer/getBusinessUnits",
    SaveCustomer: "customer",
    SaveBusinessUnit: "customer/saveBusinessUnit",
    DeleteCustomer: "customer/delete",
    GetAllAccessableBusinessUnitsByType: "customer/GetAllAccessableBusinessUnitsByType",    
    DeleteBusinessUnit: "customer/deleteBusinessUnit",
    CloneRole: "customer/cloneRole",
    SaveRole: "customer/saveRole",
    GetCustomerId: "customer/getCustomerId",
    GetBusinessUnitId: "customer/getBusinessUnitId",
    GetCustomerBusinessUnitIds: "customer/GetCustomerBusinessUnitIds",
    GetCustomerBusinessUnits: "customer/GetCustomerBusinessUnits",
    IsHostedCustomer: "customer/isHostedCustomer",    
    SendBuyFullVersionRequest: "customer/SendBuyFullVersionRequest",
    CanContactShipManagersDirectly: "customer/canContactShipManagersDirectly",
    GetCustomerAllowedDomains: "customer/GetCustomerAllowedDomains",
    UpdateCustomerAllowedDomains: "customer/UpdateCustomerAllowedDomains",
    GetBusinessUnitAllowedDomains: "customer/GetBusinessUnitAllowedDomains",
    UpdateBusinessUnitAllowedDomains: "customer/UpdateBusinessUnitAllowedDomains"
};

export const CustomerTypes = {
    Bank: "Bank",
    Broker: "Broker",
    Port: "Port",
    Terminal: "Terminal",
    Charterer: "Charterer",
    ShipOwner: "Ship Owner",
    ShipManager: "Ship Manager"
};
